import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';

import { ApiService, ConfigService } from '@app-core/services';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import * as ConfigActions from './config.actions';

@Injectable()
export class ConfigEffects {
  private _actions$ = inject(Actions);
  private _apiService = inject(ApiService);
  private _configService = inject(ConfigService);

  getInitialLayout$: Observable<Action> = createEffect(() =>
    this._actions$.pipe(
      ofType(ConfigActions.GET_INITIAL_LAYOUT),
      tap(() => this._configService.initialLoadingStop()),
      mergeMap((action: ConfigActions.GetInitialLayoutAction) => {
        return this._apiService.getClientInfo(action.payload).pipe(
          map((payload) => {
            this._configService.initialLoadingStop();

            return { type: ConfigActions.GET_INITIAL_LAYOUT_SUCCESS, payload };
          }),
          catchError((payload) => of({ type: ConfigActions.CONFIG_FAILURE, payload }))
        );
      })
    )
  );
}
